import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    AccordionItemDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getAccordionSurfaceStyle
} from "../../stylesheet";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        borderStyle: "solid",
        minWidth: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    shadowAlpha,
    elevations,
    isDisabled,
    radiuses,
    borders,
    variant,
    layout,
    colors
}: AccordionItemDynamicStyleType) => {
    const styles = {
        container: {} as Mutable<ViewStyle>
    };

    if(variant === "card") {
        Object.assign(styles.container, getAccordionSurfaceStyle({
            shadowAlpha,
            elevations,
            isDisabled,
            borders,
            colors
        }), getCornerStyle({
            radius: radiuses.surface,
            shapeConfigs
        }));

        return styles;
    }

    if(!layout.isLast) {
        Object.assign(styles.container, {
            borderBottomColor: colors.content.border.subtle,
            borderBottomWidth: borders.separator
        });
    }

    return styles;
};
export default stylesheet;
